
import {Component, Prop, Ref, Vue, Watch} from 'vue-property-decorator';
import Register from '@/components/card/Register.vue'
import Login from '@/components/card/Login.vue'

@Component({components: {Register, Login}})

export default class ValidateCustomized extends Vue {


    @Ref()
    private form: any;
    private customizedJson: string = '';
    private error: string = '';


    private resetForm() {
        this.form.reset();
    }

    private submitForm() {
      try {
          this.error = "";
          const obj = JSON.parse(this.customizedJson);
          this.error = 'Fehlerfrei';
      }catch(e:any) {
          this.error = e.message;
      }
    }

}
